export default "__VITE_ASSET__1c4oYIFk__"